import stepDialog from './index.vue';

stepDialog.install = (Vue) => {
  Vue.component(stepDialog.name, stepDialog);
};

export default stepDialog;
